import { Formik } from "formik";
import { FilterPopover } from "../../productFilters/components/desktop/FilterPopover";
import { useFacets } from "../../productFilters/hooks/useFacets";
import { useFilterContext } from "../../productFilters/contexts/FilterProvider";
import Button, { BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import PropTypes from "prop-types";
import "./FilterSortBar.scss";
import { SortPopover } from "../../productSort/components/desktop/SortPopover";
import { FilterSortBarLoader } from "./FilterSortBarLoader";
import classNames from "classnames";
import { useRef } from "react";

export const FilterSortBar = ({
	isLoading,
	isSortAvailable = true,
	onSubmit,
	onFilterOpen,
	onFilterSubmit,
	onSortSubmit,
	onSortOpen,
	className,
}) => {
	const { closeFacet, filters, setFilters, selectedFiltersCount } = useFilterContext();
	const { facets } = useFacets();
	const boundaryRef = useRef();

	const handleFilterSubmit = values => {
		setFilters(values);

		if (onSubmit) {
			onSubmit(values);
		}

		closeFacet();
	};

	const handleSortSubmit = values => {
		if (onSortSubmit) {
			onSortSubmit(values?.sortBy);
		}
		if (onSubmit) {
			onSubmit(values?.sortBy);
		}
	};

	const handleReset = () => {
		const emptyFilters = Object.fromEntries(
			Object.keys(filters).map(filterId => [filterId, []])
		);

		if (onSubmit) {
			onSubmit(emptyFilters);
		}

		setFilters(emptyFilters);
	};

	if (isLoading) {
		return <FilterSortBarLoader />;
	}

	if (!facets || facets.length === 0) {
		return null;
	}

	return (
		<section
			className={classNames("filter-sort-bar", className)}
			role="toolbar"
			data-testid="filter-sort-bar"
			ref={boundaryRef}
		>
			{isSortAvailable && (
				<SortPopover
					onSubmit={handleSortSubmit}
					boundaryRef={boundaryRef}
					onOpen={onSortOpen}
				/>
			)}

			<Formik initialValues={filters} onSubmit={handleFilterSubmit} enableReinitialize>
				<>
					{facets.map(facet => {
						return (
							<FilterPopover
								key={facet.facetId}
								facetId={facet.facetId}
								onSubmit={onFilterSubmit}
								onOpen={onFilterOpen}
								boundaryRef={boundaryRef}
							>
								{facet.facetTitle}
							</FilterPopover>
						);
					})}

					{selectedFiltersCount > 0 && (
						<Button
							className="filter-sort-bar__reset-button"
							onClick={handleReset}
							data-testid="sdp-horizontal-filters-reset"
							variant={BUTTON_VARIANTS.BORDERLESS}
							label={
								<Typography
									variant={TYPOGRAPHY_VARIANTS.SMALL}
									component="span"
									isBold
									className="filter-sort-bar__reset-button-text"
								>
									<FormattedMessage id="general.filter.raz.label" />
								</Typography>
							}
						/>
					)}
				</>
			</Formik>
		</section>
	);
};

FilterSortBar.propTypes = {
	isLoading: PropTypes.bool.isRequired,
	isSortAvailable: PropTypes.bool,
	onSubmit: PropTypes.func,
	onFilterSubmit: PropTypes.func,
	onSortSubmit: PropTypes.func,
	onSortOpen: PropTypes.func,
	onFilterOpen: PropTypes.func,
	className: PropTypes.string,
};
